var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { staticClass: "d-flex justify-content-end", attrs: { cols: "12" } },
        [
          _vm.HasPermission(_vm.PermissionList.Sales_Create)
            ? _c(
                "b-button",
                {
                  attrs: {
                    variant: "primary",
                    to: { name: "quotation-add" },
                    disabled: _vm.loading,
                  },
                },
                [_vm._v(" Add Quotation ")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "b-col",
        { staticClass: "my-1", attrs: { cols: "12", md: "2", sm: "2" } },
        [
          _c(
            "b-form-group",
            { staticClass: "mb-0" },
            [
              _c(
                "label",
                { staticClass: "d-inline-block text-sm-left mr-50" },
                [_vm._v("Per page")]
              ),
              _c("b-form-select", {
                attrs: {
                  id: "perPageSelect",
                  size: "sm",
                  options: _vm.pageOptions,
                },
                model: {
                  value: _vm.perPage,
                  callback: function ($$v) {
                    _vm.perPage = $$v
                  },
                  expression: "perPage",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-col",
        {
          staticClass: "d-flex justify-content-end mb-2",
          staticStyle: { position: "relative", "z-index": "1" },
          attrs: { cols: "12" },
        },
        [
          _vm.HasPermission(_vm.PermissionList.Sales_Search)
            ? _c(
                "b-button",
                {
                  attrs: {
                    variant: "outline-danger",
                    disabled: !_vm.anyFilterActive,
                  },
                  on: { click: _vm.clearFilters },
                },
                [_vm._v(" Clear Filters ")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c("b-table", {
            attrs: {
              striped: "",
              hover: "",
              responsive: "",
              "per-page": _vm.perPage,
              "current-page": _vm.currentPage,
              items: _vm.filteredQuotations,
              fields: _vm.fields,
              "sort-by": _vm.sortBy,
              "sort-desc": _vm.sortDesc,
              "sort-direction": _vm.sortDirection,
            },
            on: {
              "update:sortBy": function ($event) {
                _vm.sortBy = $event
              },
              "update:sort-by": function ($event) {
                _vm.sortBy = $event
              },
              "update:sortDesc": function ($event) {
                _vm.sortDesc = $event
              },
              "update:sort-desc": function ($event) {
                _vm.sortDesc = $event
              },
              filtered: _vm.onFiltered,
            },
            scopedSlots: _vm._u([
              {
                key: "head(quotationNo)",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c("span", [_vm._v("Quotation No")]),
                        _c("b-form-input", {
                          attrs: {
                            placeholder: "Filter by Quotation No",
                            size: "sm",
                          },
                          on: { input: _vm.filterTable },
                          model: {
                            value: _vm.columnFilters.quotationNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.columnFilters, "quotationNo", $$v)
                            },
                            expression: "columnFilters.quotationNo",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "head(leadClientName)",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c("span", [_vm._v("Customer")]),
                        _c("b-form-input", {
                          attrs: {
                            placeholder: "Filter by Customer",
                            size: "sm",
                          },
                          on: { input: _vm.filterTable },
                          model: {
                            value: _vm.columnFilters.customer,
                            callback: function ($$v) {
                              _vm.$set(_vm.columnFilters, "customer", $$v)
                            },
                            expression: "columnFilters.customer",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "head(leadClientEmail)",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c("span", [_vm._v("Customer Email")]),
                        _c("b-form-input", {
                          attrs: {
                            placeholder: "Filter by Customer Email",
                            size: "sm",
                          },
                          on: { input: _vm.filterTable },
                          model: {
                            value: _vm.columnFilters.customerEmail,
                            callback: function ($$v) {
                              _vm.$set(_vm.columnFilters, "customerEmail", $$v)
                            },
                            expression: "columnFilters.customerEmail",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "head(salesPersonId)",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c("span", [_vm._v("Sales Person")]),
                        _c("b-form-input", {
                          attrs: {
                            placeholder: "Filter by Sales Person",
                            size: "sm",
                          },
                          on: { input: _vm.filterTable },
                          model: {
                            value: _vm.columnFilters.salesPerson,
                            callback: function ($$v) {
                              _vm.$set(_vm.columnFilters, "salesPerson", $$v)
                            },
                            expression: "columnFilters.salesPerson",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "head(priority)",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c("span", [_vm._v("Priority")]),
                        _c(
                          "b-form-select",
                          {
                            staticClass: "auto-width",
                            attrs: { size: "md" },
                            on: { change: _vm.filterTable },
                            model: {
                              value: _vm.columnFilters.priority,
                              callback: function ($$v) {
                                _vm.$set(_vm.columnFilters, "priority", $$v)
                              },
                              expression: "columnFilters.priority",
                            },
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v("All"),
                            ]),
                            _c("option", { attrs: { value: "LOW" } }, [
                              _vm._v("LOW"),
                            ]),
                            _c("option", { attrs: { value: "MEDIUM" } }, [
                              _vm._v("MEDIUM"),
                            ]),
                            _c("option", { attrs: { value: "HIGH" } }, [
                              _vm._v("HIGH"),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "head(dueDate)",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c("span", [_vm._v("Due Date")]),
                        _c("date-picker", {
                          staticClass: "small-datepicker",
                          attrs: {
                            range: true,
                            format: "YYYY-MM-DD",
                            placeholder: "Select Date Range",
                            clearable: false,
                            "input-attr": { readonly: true },
                          },
                          on: {
                            change: _vm.filterTable,
                            focus: _vm.openCalendar,
                          },
                          model: {
                            value: _vm.columnFilters.dueDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.columnFilters, "dueDate", $$v)
                            },
                            expression: "columnFilters.dueDate",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "head(createdOn)",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c("span", [_vm._v("Created On")]),
                        _c("date-picker", {
                          staticClass: "small-datepicker",
                          attrs: {
                            range: true,
                            format: "YYYY-MM-DD",
                            placeholder: "Select Date Range",
                            clearable: false,
                            "input-attr": { readonly: true },
                          },
                          on: {
                            change: _vm.filterTable,
                            focus: _vm.openCalendar,
                          },
                          model: {
                            value: _vm.columnFilters.createdOn,
                            callback: function ($$v) {
                              _vm.$set(_vm.columnFilters, "createdOn", $$v)
                            },
                            expression: "columnFilters.createdOn",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "head(status)",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column" },
                      [
                        _c("span", [_vm._v("STATUS")]),
                        _c(
                          "b-form-select",
                          {
                            attrs: { size: "sm" },
                            on: { change: _vm.filterTable },
                            model: {
                              value: _vm.columnFilters.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.columnFilters, "status", $$v)
                              },
                              expression: "columnFilters.status",
                            },
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v("All"),
                            ]),
                            _c("option", { attrs: { value: "NEW" } }, [
                              _vm._v("NEW"),
                            ]),
                            _c("option", { attrs: { value: "PROFORMA" } }, [
                              _vm._v("PROFORMA"),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "cell(status)",
                fn: function (data) {
                  return [
                    data.item.status === 0
                      ? _c("b-badge", { attrs: { variant: "secondary" } }, [
                          _vm._v("New"),
                        ])
                      : data.item.status === 3
                      ? _c("b-badge", { attrs: { variant: "info" } }, [
                          _vm._v("Proforma"),
                        ])
                      : _vm._e(),
                  ]
                },
              },
              {
                key: "cell(total)",
                fn: function (data) {
                  return [
                    _vm.HasPermission(_vm.PermissionList.Sales_Finance)
                      ? [
                          _vm._v(
                            " " +
                              _vm._s(
                                data.item.currency == null
                                  ? "Rs"
                                  : _vm.getCurrencySymbol(data.item.currency)
                              ) +
                              " " +
                              _vm._s(data.item.total.toFixed(2)) +
                              " "
                          ),
                        ]
                      : void 0,
                  ]
                },
              },
              {
                key: "cell(dueDate)",
                fn: function (data) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm.convertTimestampToDate(data.item.dueDate)) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "cell(createdOn)",
                fn: function (data) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.convertTimestampToDate(data.item.createdOn)
                        ) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "cell(salesPersonId)",
                fn: function (data) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm.getSalePersonName(data.item.salesPersonId)) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "cell(actions)",
                fn: function (data) {
                  return [
                    _c(
                      "b-dropdown",
                      {
                        attrs: {
                          variant: "link",
                          "toggle-class": "text-decoration-none",
                          "no-caret": "",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "button-content",
                              fn: function () {
                                return [
                                  _c("feather-icon", {
                                    staticClass: "text-body align-middle mr-25",
                                    attrs: {
                                      icon: "MoreVerticalIcon",
                                      size: "16",
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                      },
                      [
                        _vm.HasPermission(_vm.PermissionList.Sales_View)
                          ? _c(
                              "b-dropdown-item",
                              {
                                directives: [
                                  {
                                    name: "b-modal",
                                    rawName: "v-b-modal.modal-edit",
                                    modifiers: { "modal-edit": true },
                                  },
                                ],
                                attrs: { to: _vm.getQuotationId(data.item.id) },
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "mr-50",
                                  attrs: { icon: "EyeIcon" },
                                }),
                                _c("span", [_vm._v("View")]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.HasPermission(_vm.PermissionList.Sales_Update) &&
                        data.item.status != 3
                          ? _c(
                              "b-dropdown-item",
                              {
                                directives: [
                                  {
                                    name: "b-modal",
                                    rawName: "v-b-modal.modal-edit",
                                    modifiers: { "modal-edit": true },
                                  },
                                ],
                                attrs: {
                                  to: _vm.getQuotationEdit(data.item.id),
                                },
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "mr-50",
                                  attrs: { icon: "Edit2Icon" },
                                }),
                                _c("span", [_vm._v("Edit")]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.HasPermission(_vm.PermissionList.Sales_Delete)
                          ? _c(
                              "b-dropdown-item",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.removequotation(data.item.id)
                                  },
                                },
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "mr-50",
                                  attrs: { icon: "TrashIcon" },
                                }),
                                _c("span", [_vm._v("Delete")]),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c(
            "div",
            { staticClass: "d-flex justify-content-center mb-1" },
            [
              _vm.quotationList.length === 0
                ? _c(
                    "b-alert",
                    {
                      staticClass: "d-flex justify-content-center",
                      attrs: { variant: "warning", show: "" },
                    },
                    [
                      _c("h4", { staticClass: "alert-heading" }, [
                        _vm._v("No Quotations yet"),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "d-flex justify-content-center mb-1" },
            [
              _vm.loading
                ? _c("b-spinner", {
                    staticStyle: { width: "3rem", height: "3rem" },
                    attrs: { variant: "success", label: "Spinning", block: "" },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c("b-pagination", {
            staticClass: "my-0",
            attrs: {
              "total-rows": _vm.totalRows,
              "per-page": _vm.perPage,
              align: "center",
              size: "sm",
            },
            model: {
              value: _vm.currentPage,
              callback: function ($$v) {
                _vm.currentPage = $$v
              },
              expression: "currentPage",
            },
          }),
          _c("b-form-group", [
            _vm._v(
              " Showing " +
                _vm._s(
                  _vm.totalRows > 0
                    ? _vm.perPage * (_vm.currentPage - 1) + 1
                    : 0
                ) +
                " to " +
                _vm._s(
                  _vm.totalRows > 0
                    ? Math.min(_vm.perPage * _vm.currentPage, _vm.totalRows)
                    : 0
                ) +
                " of " +
                _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                " entries "
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }